import { scheduleData } from '@/mocks/anime';

export default function ScheduleSection() {
  return (
    <section id="schedule" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-2xl">
            <span className="text-xs font-medium tracking-wide text-primary-600">更新时间表</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              一周更新安排，按天追更不迷路
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              连载作品一般按周更新，下面按星期整理了大致的更新日与时间段，方便安排观看节奏。具体更新以当周实际进度为准。
            </p>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-600">
            <span className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-full bg-primary-500"></span>
              连载更新
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-full bg-accent-500"></span>
              特别篇 / 合集
            </span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-3">
          {scheduleData.map((day) => (
            <div
              key={day.day}
              className="rounded-lg border border-background-200 bg-background-50 p-4 flex flex-col"
            >
              <div className="flex items-center gap-2 pb-3 mb-3 border-b border-background-200">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-calendar-2-line text-sm"></i>
                </span>
                <span className="text-sm font-semibold text-foreground-900">{day.day}</span>
              </div>

              <div className="flex-1 space-y-3">
                {day.items.map((item) => (
                  <div
                    key={`${day.day}-${item.title}`}
                    className="rounded-md bg-background-100 px-3 py-2.5"
                  >
                    <div className="flex items-start justify-between gap-2">
                      <h3 className="text-xs font-medium text-foreground-900 leading-snug">
                        {item.title}
                      </h3>
                      <span className="shrink-0 text-[11px] text-foreground-500">{item.time}</span>
                    </div>
                    <div className="mt-1.5 flex items-center gap-1.5">
                      <span
                        className={`w-1.5 h-1.5 rounded-full ${
                          item.episode.includes('特别') || item.episode.includes('合集') || item.episode.includes('篇')
                            ? 'bg-accent-500'
                            : 'bg-primary-500'
                        }`}
                      ></span>
                      <span className="text-[11px] text-foreground-600">{item.episode}</span>
                      <span className="text-[11px] text-secondary-700">· {item.genre}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}